import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/Home/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About/About.vue')
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product/Product.vue')
  },
  {
    path: '/proDetails',
    name: 'proDetails',
    component: () => import('../views/Product/proDetails.vue')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('../views/Show/details.vue')
  },
  {
    path: '/serve',
    name: 'Serve',
    component: () => import('../views/Serve/Serve.vue')
  },
  {
    path: '/show',
    name: 'Show',
    component: () => import('../views/Show/Show.vue')
  },
  {
    path: '/news',
    name: 'News',
    component: () => import('../views/News/News.vue')
  },
  {
    path: '/newsDetails',
    name: 'newsDetails',
    component: () => import('../views/News/newsDetails.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('../views/Contact/Contact.vue')
  },
  {
    path:'/',
    redirect:"/home"
  }
  /* {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/About.vue')
  } */
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
